export const ROUTES = {
  LANDING: '/',
  HOME: '/home',
};

export const DEFAULT_WIDTH = "1000";
export const DEFAULT_HEIGHT = "1000";
export const DEFAULT_VIEWBOX = "0 0 1000 1000";
